import { PagePaths } from '@revelio/core';

/**
 * Paths where the global assistant is hidden. Custom Dash report editors live
 * at `/report/:templateId` and use the in-page Report AI assistant instead.
 * Legacy MW report builder, sample reports, and the reports list remain visible
 * so report-offer handoffs can continue in chat.
 */
const hiddenGlobalAIAssistantPathSegments = [
  'admin',
  'manage',
  'report',
  PagePaths.DATA_BUILDER,
  PagePaths.DATA_BUILDER_STATUS,
  `${PagePaths.DELIVERABLES}/${PagePaths.DATA_ENRICHMENT}`,
  PagePaths.RESUME_ENRICHMENT,
] as const;

function pathnameMatchesTopLevelSegment(
  pathname: string,
  segment: string
): boolean {
  return pathname === `/${segment}` || pathname.startsWith(`/${segment}/`);
}

export function shouldHideGlobalAIAssistantForPathname(
  pathname: string
): boolean {
  return hiddenGlobalAIAssistantPathSegments.some((segment) =>
    pathnameMatchesTopLevelSegment(pathname, segment)
  );
}
